import styles from "./PPTPollsPage.module.css";
import {
    POLL_TYPE,
} from "../../utils/constants";

import {getShortName, } from "../../utils/helpers";
import React, {useEffect, useState} from "react";
import {QRCodeCanvas} from "qrcode.react";
import {useParams} from "react-router-dom";
import {ReactComponent as LOGO_ICON} from "../../images/yujalogo.svg"
import {PollApiCalls} from "../../apis/PollApiCalls";
import Skeleton from "react-loading-skeleton";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {useConfig} from "../../hooks/useConfig";
import { useTranslation } from "react-i18next";



export default function SlideInstructionTemplate({ }) {
    const { t } = useTranslation();
    const {getPublishedPollDataFromKey, } = PollApiCalls();
    const {getRedirectUrl, canHavePollCode} = useSynLMSConfiguration();
    const config = useConfig();

    let {pollKey, pollCode} = useParams();
    let shortName = getShortName();
    const HOST = shortName + '.' + config.host_url;
    const [dataReady, setDataReady] = useState(false);
    const [poll, setPoll] = useState({});

    useEffect(() => {
       getPublishedPollDataFromKey(pollKey, pollCode).then(res => {
            let {poll= {}} = res;
           setPoll(poll);
        }).finally(() => {
           setDataReady(true);
       });

    }, []);

    if (!dataReady) {
        return (
            <div className={`${styles.canvas}`}>
                <Skeleton borderRadius={10} inline={true} width={"100%"} height={"100%"}/>
            </div>
        );
    }


    let redirectUrl = getRedirectUrl(poll);
    let isPollCodeVisible = canHavePollCode(poll);

    const renderLeftPortion = () => {
        return (
            <div
                className={`${styles.canvasLeftPart} ${styles.column}`}
                style={{height: "100%", alignItems: "center", position: "relative"}}
            >
                <div style={{flex: 1}}/>
                {!!redirectUrl &&
                    <>
                        <span
                            style={{fontSize: 18, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}
                        >{poll.pollTitle}</span>
                        {isPollCodeVisible &&
                            <>
                                <span className={styles.canvasJoinText}>{t("poll.joinAt", {url: HOST})}</span>
                                <span className={styles.pollCodeBadge}>{t("poll.useCode", {code: pollCode})}</span>
                            </>
                        }


                        <div className={styles.QRCodeWrapper} style={{marginTop: 25}}>
                            <QRCodeCanvas
                                id={`QR${pollCode}`}
                                size={130}
                                renderAs="canvas"
                                value={redirectUrl}
                            />
                        </div>
                    </>
                }

                {!redirectUrl &&
                    <span style={{fontSize: 25, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}>
                        {poll.pollTitle}
                    </span>
                }

                <div style={{flex: 1}}/>
            </div>
        );
    }


    return (
        <div>
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={`instruction`}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column}
                     style={{flex: 1, minWidth: 0, height: "100%", padding: 90, alignItems: "center"}}>
                    <span
                        className={`${styles.poweredYuJaText} ${styles.row}`}
                        style={{gap: 7, width: 'fit-content'}}
                    >
                        <LOGO_ICON style={{width: 22, height: 22}}/>
                        {t("auth.loginPageFooter")}
                    </span>

                    <span className={styles.canvasTitle} style={{marginTop: 9}}>
                       {poll.pollType === POLL_TYPE.ATTENDANCE
                           ? t("poll.joinEngageAttendance")
                           : t("poll.joinEngagePoll")
                       }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 60}}>
                        {t("poll.pptInstructionSlideStepIntroduction")}
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 40}}>
                        {poll.pollType === POLL_TYPE.ATTENDANCE
                            ? t("poll.pptInstructionSlideStep1Attendance")
                            : t("poll.pptInstructionSlideStep1Poll")
                        }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 30}}>
                         {poll.pollType === POLL_TYPE.ATTENDANCE
                             ? t("poll.pptInstructionSlideStep2Attendance")
                             : t("poll.pptInstructionSlideStep2Poll")
                         }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 30}}>
                        {t("poll.pptInstructionSlideStep3")}
                    </span>
                </div>
            </div>
        </div>

    );
}